






















































































































































































































import Vue from 'vue';
import { isArray } from 'expangine-runtime';
import { SimpleFieldOption } from '../common';
import { Icons } from '../app/Icons';



export default Vue.extend({
  name: 'ex-simple-fields',
  props: {
    value: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array as () => SimpleFieldOption[],
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icons: () => Icons,
  },
  methods: {
    hideDetails(field: SimpleFieldOption, index: number): boolean {
      const next = this.fields[index + 1];
      return !this.getDetails(field) && (!next || next.type === 'boolean');
    },
    getDetails(field: SimpleFieldOption): string {
      const error = this.getError(field);
      return error || field.details || '';
    },
    getError(field: SimpleFieldOption): string {
      if (field.getError) {
        const error = field.getError(this.value[field.name], this.value);
        if (error) {
          return error;
        }
      }
      return '';
    },
    toNumber(value: any): number | undefined {
      const parsed = parseFloat(value);
      return isFinite(parsed) ? parsed : undefined;
    },
    setField(field: SimpleFieldOption, value: any) {
      const isEmpty = value === undefined || value === null || value === field.defaultValue;
      if (isEmpty && !field.required) {
        this.$delete(this.value, field.name);
      } else {
        this.$set(this.value, field.name, value);
      }
      this.update();
    },
    addFieldObject(field: SimpleFieldOption) {
      this.$set(this.value, field.name, {});
      this.update();
    },
    getItems(field: SimpleFieldOption) {
      let items = this.value[field.name];
      if (!isArray(items)) {
        this.$set(this.value, field.name, items = []);
      }
      return items;
    },
    removeItem(field: SimpleFieldOption, index: number) {
      const items = this.getItems(field);
      items.splice(index, 1);
      this.update();
    },
    setItemText(field: SimpleFieldOption, index: number, text: string) {
      const items = this.getItems(field);
      this.$set(items[index], 'text', text);
      this.update();
    },
    setItemValue(field: SimpleFieldOption, index: number, value: string) {
      const items = this.getItems(field);
      this.$set(items[index], 'value', value);
      this.update();
    },
    addItem(field: SimpleFieldOption) {
      const items = this.getItems(field);
      const count = items.length + 1;
      items.push({
        text: 'Text #' + count,
        value: field.valueType === 'number' ? count : 'Value #' + count,
      });
      this.update();
    },
    update() {
      this.$emit('input', this.value);
    },
  },
});
